module.exports = __webpack_public_path__ + "img/MerchantRedirectCPC.8a14f955.svg";